import React from 'react'
import { Link as RRLink, LinkProps as RRLinkProps } from "react-router-dom";
import {
  Link as ChakraLink,
  LinkProps as ChakraLinkProps,
} from "@chakra-ui/react";

const Link: React.FC<ChakraLinkProps & RRLinkProps> = ({
  children,
  ...props
}) => (
  <ChakraLink as={RRLink} {...props} color="blue.600">
    {children}
  </ChakraLink>
);

export default Link